module.exports = __webpack_public_path__ + "img/notpaid.934faa58.svg";